import { action } from 'typesafe-actions';

import * as Types from 'types';

import { ModalActionTypes } from './types';

export const showErrorModal = (
  message: string,
  urlToGoAfterModalClose?: string,
) =>
  action(ModalActionTypes.SHOW_ERROR_MODAL, {
    message,
    urlToGoAfterModalClose,
  });

const _hideErrorModal = () => {
  return action(ModalActionTypes.HIDE_ERROR_MODAL);
};

export const Actions = {
  showErrorModal,
  _hideErrorModal,
};

export const hideErrorModal = (): Types.DefaultThunkAction => (
  dispatch,
  getState,
) => {
  dispatch(_hideErrorModal());
  const { modals } = getState();
  if (modals.urlToGoAfterModalClose) {
    window.history.pushState(null, '', modals.urlToGoAfterModalClose);
  }
};
